import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { HeaderIconL } from "../../../assets/components/HeaderGroup";
import back from "../../../assets/icons/Arrow/left.svg"

function normalizeUrl(raw) {
  if (!raw || typeof raw !== "string") return "https://jyesapps.github.io/kakaomap/?inapp=1";
  let u = raw.trim();
  if (!/^https?:\/\//i.test(u)) u = "https://" + u;
  try {
    const url = new URL(u);
    if (url.protocol !== "http:" && url.protocol !== "https:") {
      return "https://jyesapps.github.io/kakaomap/?inapp=1";
    }
    return url.toString();
  } catch {
    return "https://jyesapps.github.io/kakaomap/?inapp=1";
  }
}

export default function AddressInApp() {
  const navigate = useNavigate();
  const location = useLocation(); // ★ 복귀 경로용
  const [searchParams] = useSearchParams();
  const iframeRef = useRef(null);

  // 호출 측에서 navigate('/inapp/address?...', { state: { returnTo: location } }) 형태로 띄우면,
  // 여기서 복귀 경로를 안전하게 가져올 수 있어요.
  const returnTo = location.state?.returnTo || null;

  const targetUrl = useMemo(
    () => normalizeUrl(searchParams.get("url") || "https://jyesapps.github.io/kakaomap/?inapp=1"),
    [searchParams]
  );

  const [loading, setLoading] = useState(true);

  // 부모로 결과 전파 + 안전 복귀
  const closeWithResult = (payload) => {
    // 기존 방식: CustomEvent 유지 (기존 페이지에서 이미 이 이벤트를 듣고 있다면 그대로 동작)
    if (payload) {
      window.dispatchEvent(new CustomEvent("POSTCODE_SELECTED", { detail: payload }));
    } else {
      window.dispatchEvent(new CustomEvent("POSTCODE_CLOSED"));
    }

    // ★ history 의존 회피: 복귀 경로가 있으면 거기로 replace 이동하며 state로도 결과 전달
    if (returnTo && typeof returnTo === "object") {
      const toPath = (returnTo.pathname || "/") + (returnTo.search || "") + (returnTo.hash || "");
      navigate(toPath, {
        replace: true,
        state: {
          ...returnTo.state,
          // 선택 결과를 state로도 넘겨주면, 이벤트를 못 듣는 환경에서도 안전함
          postcodeResult: payload || null,
        },
      });
    } else {
      // 폴백
      navigate(-1);
    }
  };

  useEffect(() => {
    let ALLOWED = "";
    try { ALLOWED = new URL(targetUrl).origin; } catch { }

    const onMsg = (ev) => {
      // Android/WebView에서 origin이 'null'인 경우가 있어, iframe source 매칭도 함께 허용
      const fromIframe = iframeRef.current && ev.source === iframeRef.current.contentWindow;
      const allowedOrigin =
        (ALLOWED && ev.origin === ALLOWED) || ev.origin === "null" || ev.origin === null;

      if (!fromIframe && !allowedOrigin) return;

      const { type, road, zip } = (ev.data || {});
      if (type === "POSTCODE_SELECTED") {
        closeWithResult({ road, zip });
      } else if (type === "POSTCODE_CLOSED") {
        closeWithResult(null);
      }
    };

    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, [targetUrl]); // navigate/returnTo는 내부 함수에서 캡처

  return (
    <div className="fixed inset-0 z-[9999] bg-white flex flex-col">
      <HeaderIconL
        title="우편번호 검색"
        icon={back}
        onIconClick={() => closeWithResult(null)}
      />

      {/* 본문 iframe */}
      <div className="flex-1 overflow-hidden pt-[40px]">
        <iframe
          ref={iframeRef}
          title="Address Picker"
          src={targetUrl}
          onLoad={() => setLoading(false)}
          className="w-full h-full overflow-auto"
          style={{ WebkitOverflowScrolling: "touch" }}
          // 팝업이 새 창으로 빠져나가며 선택 후 빈(흰) 페이지가 남는 케이스 방지
          //   - allow-popups-to-escape-sandbox: 일부 위젯이 window.open → close 흐름을 써도 정상 동작
          //   - top 네비는 계속 차단(escape는 팝업에 한정)
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
          allow="fullscreen"
        />
      </div>

      {loading && (
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 text-xs text-gray-500">
          로딩 중…
        </div>
      )}
    </div>
  );
}
